export { default, FEEDBACK_CHARACTER_LIMIT } from './FeedbackModal';
export type { FeedbackModalCopy } from './FeedbackModal';
